import React from 'react';
import Text from '@lightspeed/cirrus-text';

const Building = ({ show }) => (
  <div style={{ display: show ? 'block' : 'none' }}>
    <img
      src="https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-9919532/images/ecom/launch2_sm.gif"
      width="400"
      height="322"
      alt="eCom provisioning building"
    />
    <Text body bold className="cr-text-center">
      Building your online store...
    </Text>
  </div>
);

export default Building;
